export type ShareableLinksPreferences = {
  showInactive: boolean;
};

export const SHAREABLE_LINKS_PREFERENCES_KEY = 'shareableLinks.preferences';

export const DEFAULT_SHAREABLE_LINKS_PREFERENCES: ShareableLinksPreferences = {
  showInactive: false,
};

export function updateShowInactivePreference(
  preferences: ShareableLinksPreferences,
  showInactive: boolean
): ShareableLinksPreferences {
  return {
    ...preferences,
    showInactive,
  };
}
